import queryString from "query-string";

import { SALE_ATTRIBUTES } from "constants/actionTypes";

import { URLCreatorProps } from "actions/types";
import { serializeSaleAttributes } from "lib/serializers/saleAttributes";

import { offlineActionCreator, urlCheckAndAddIdAndAction } from "./lib";

const urlCreator = ({ changesSince, id, action }: URLCreatorProps = {}) =>
  queryString.stringifyUrl({
    url: urlCheckAndAddIdAndAction("/v2/sale-attributes/", id, action),
    query: {
      changesSince,
    },
  });

export const SaleAttributesAction = offlineActionCreator(
  SALE_ATTRIBUTES,
  serializeSaleAttributes,
  urlCreator,
  false,
);
